"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _baseService = _interopRequireDefault(require("@/config/base-service"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var UsersService = /*#__PURE__*/function (_BaseService) {
  function UsersService() {
    _classCallCheck(this, UsersService);
    return _callSuper(this, UsersService, ['']);
  }
  _inherits(UsersService, _BaseService);
  return _createClass(UsersService, [{
    key: "fetchAll",
    value: function fetchAll() {
      return this.get("users");
    }
  }, {
    key: "fetchItem",
    value: function fetchItem(id) {
      return this.get("users/".concat(id));
    }
  }, {
    key: "create",
    value: function create(payload) {
      return this.post(payload, "users");
    }
  }, {
    key: "update",
    value: function update(payload, id) {
      return this.put(payload, "persons/".concat(id));
    }
  }, {
    key: "deleteItem",
    value: function deleteItem(id) {
      return this.delete("persons/".concat(id));
    }
  }, {
    key: "fetchEndUsers",
    value: function fetchEndUsers() {
      return this.get("persons/all");
    }
  }, {
    key: "createOrganizationPersons",
    value: function createOrganizationPersons(payload) {
      return this.post(payload, "organizations/users");
    }
  }, {
    key: "fetchAllOrganizationPersons",
    value: function fetchAllOrganizationPersons(idUser) {
      return this.get("organizations/users/".concat(idUser));
    }
  }, {
    key: "fetchAllPersonOrganizations",
    value: function fetchAllPersonOrganizations(idOrganization) {
      return this.get("organizationPersons/all/organization/".concat(idOrganization));
    }
  }, {
    key: "deleteOrganizationPersons",
    value: function deleteOrganizationPersons(id) {
      return this.delete("organizations/users/".concat(id));
    }
  }, {
    key: "updatePass",
    value: function updatePass(payload, id) {
      return this.put(payload, "users/update/pass/".concat(id));
    }
  }, {
    key: "sendCredentialUserMail",
    value: function sendCredentialUserMail(payload) {
      return this.post(payload, "notifications/send/credentials-user");
    }
  }, {
    key: "fetchAllAccessUser",
    value: function fetchAllAccessUser(_ref) {
      var idUser = _ref.idUser,
        params = _ref.params;
      return this.get("access/user/list/".concat(idUser), {
        params: params
      });
    }
  }]);
}(_baseService.default);
var _default = exports.default = new UsersService();